"use client";

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { useTheme } from "@/lib/theme";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/** Toasts confirm an action where the eye already is: top centre, just under the top bar, each
 * tinted by what happened (done, careful, failed) so a glance is enough. Errors stay longer. */
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      offset={60}
      duration={4500}
      icons={{
        success: <CircleCheckIcon className="size-[18px]" />,
        info: <InfoIcon className="size-[18px]" />,
        warning: <TriangleAlertIcon className="size-[18px]" />,
        error: <OctagonXIcon className="size-[18px]" />,
        loading: <Loader2Icon className="size-[18px] animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "!font-sans !text-[14px] !gap-2.5 !rounded-lg !border !px-4 !py-3 !shadow-[var(--shadow-overlay)]",
          title: "!font-semibold",
          description: "!text-foreground/80",
          success: "!bg-ok-bg !text-ok !border-ok-bd",
          info: "!bg-info-bg !text-info !border-info-bd",
          warning: "!bg-warn-bg !text-warn !border-warn-bd",
          error: "!bg-danger-bg !text-danger !border-danger-bd",
        },
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
